module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-items-center"
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "max-height": "50%"
    }
  }, [_c('p', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "h-50 p-3"
  }, [_c('img', {
    staticClass: "mx-auto w-100 h-100",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.background_image
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4913e672"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/player/page/toptextdownpic.vue
// module id = 121
// module chunks = 0